/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {stableIdentifierStore} from '../api'

export const useMutationStableIdentifierStore = createReactQueryMutationHook('stableIdentifierStore', stableIdentifierStore)
